// extracted by mini-css-extract-plugin
export var dividerLine = "_3n-0";
export var errorBackground = "_3n-1";